<template>
  <div class="excel">
    <div class="excel_nav">
      <navbar
        title="待发货订单记录"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <span v-html="luckysheetCss"></span>
      <div
        id="luckysheet"
        style="
          margin: 0px;
          padding: 0px;
          position: absolute;
          width: 100%;
          left: 0px;
          top: 30px;
          bottom: 0px;
        "
      ></div>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import LuckyExcel from "luckyexcel";
export default {
  components: {
    navbar,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      fileSrc: "",
      fileName: "",
      luckysheetCss: "",
    };
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    document.querySelector("#luckysheet").style.top = "8.8rem";
  },
  created() {
    this.fileSrc =
      window.location.origin.split("://")[0] +
      "://" +
      this.$route.query.pdfSrc.split("://")[1];
    this.fileName = this.fileSrc.split(".com/")[1];
    this.selectExcel();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async selectExcel() {
      await this.loadJS([
        "https://cdn.jsdelivr.net/npm/luckysheet/dist/plugins/js/plugin.js",
        "https://cdn.jsdelivr.net/npm/luckysheet/dist/luckysheet.umd.js",
      ]);
      let _this = this;
      this.luckysheetCss =
        "<link rel='stylesheet' href='https://cdn.jsdelivr.net/npm/luckysheet/dist/plugins/plugins.css' /><link rel='stylesheet' href='https://cdn.jsdelivr.net/npm/luckysheet/dist/css/luckysheet.css' /><link rel='stylesheet' href='https://cdn.jsdelivr.net/npm/luckysheet/dist/assets/iconfont/iconfont.css' />";
      const value = this.fileSrc;
      const name = this.fileName;

      if (value == "") {
        return;
      }

      LuckyExcel.transformExcelToLuckyByUrl(
        value,
        name,
        (exportJson, luckysheetfile) => {
          if (exportJson.sheets == null || exportJson.sheets.length == 0) {
            alert(
              "Failed to read the content of the excel file, currently does not support xls files!"
            );
            return;
          }

          window.luckysheet.destroy();

          window.luckysheet.create({
            container: "luckysheet", //luckysheet is the container id
            showinfobar: false, //是否显示顶部信息栏
            data: exportJson.sheets, //工作表配置
            title: exportJson.info.name, // 设定表格名称
            lang: "zh", // 设定表格语言
            // userInfo: exportJson.info.name.creator,
            userInfo: false, //右上角的用户信息展示样式
            showsheetbar: false, //是否显示底部sheet页按钮
            showstatisticBar: false, //是否显示底部计数栏
            showstatisticBarConfig: {
              count: false, // 计数栏
              view: false, // 打印视图
              zoom: false, // 缩放
            },
            sheetFormulaBar: false,
            allowEdit: false,
            enableAddRow: false, //允许添加行
            enableAddCol: false,
            enableAddBackTop: false, //允许回到顶部
            cellRightClickConfig: {
              //自定义配置单元格右击菜单
              copy: false, // 复制
              copyAs: false, // 复制为
              paste: false, // 粘贴
              insertRow: false, // 插入行
              insertColumn: false, // 插入列
              deleteRow: false, // 删除选中行
              deleteColumn: false, // 删除选中列
              deleteCell: false, // 删除单元格
              hideRow: false, // 隐藏选中行和显示选中行
              hideColumn: false, // 隐藏选中列和显示选中列
              rowHeight: false, // 行高
              columnWidth: false, // 列宽
              clear: false, // 清除内容
              matrix: false, // 矩阵操作选区
              sort: false, // 排序选区
              filter: false, // 筛选选区
              chart: false, // 图表生成
              image: false, // 插入图片
              link: false, // 插入链接
              data: false, // 数据验证
              cellFormat: false, // 设置单元格格式
            },
            hook: {
              cellMousedown: function (cell, postion, sheetFile, ctx) {
                //单元格点击后的事件
                // console.log(cell.m);
                // console.log(postion);
                // console.log(sheetFile);
                // console.log(ctx);
                let tipsDom = document.querySelector(".luckysheet-tipsdom");
                // console.log(cell);
                if (
                  !cell ||
                  !cell.m ||
                  (postion.c != 4 && postion.c != 11 && postion.c != 15)
                ) {
                  if (tipsDom) {
                    tipsDom.remove();
                  }
                  return;
                }
                if (!tipsDom) {
                  var dom = document.createElement("p");
                  dom.className = "luckysheet-tipsdom";
                  dom.innerHTML = cell.m;
                  document
                    .querySelector(".luckysheet-cell-flow-clip")
                    .appendChild(dom);

                  tipsDom = document.querySelector(".luckysheet-tipsdom");
                  tipsDom.style.minWidth = "150px";
                  tipsDom.style.minHeight = "20px";
                  tipsDom.style.lineHeight = "20px";
                  tipsDom.style.maxWidth = "320px";
                  tipsDom.style.maxHeight = "438px";
                  tipsDom.style.position = "absolute";
                  tipsDom.style.zIndex = 99;
                  tipsDom.style.background = "#ccc";
                  tipsDom.style.padding = "0 5px";
                  tipsDom.style.borderRadius = "2px";
                  tipsDom.style.textAlign = "center";
                }
                tipsDom.innerHTML = cell.m;
                tipsDom.style.top = postion.end_r + "px";
                tipsDom.style.left = postion.start_c + "px";
              },
            },
          });
        }
      );
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.excel {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .excel_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
  }

  .box {
    padding: 8.8rem 0 0;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    /deep/ .luckysheet {
      // top: 5.8rem !important;

      .luckysheet-wa-editor {
        display: none !important;
      }

      .luckysheet-wa-calculate {
        display: none !important;
      }

      h3 {
        margin: 40px 0 0;
      }

      ul {
        list-style-type: none;
        padding: 0;
      }

      li {
        display: inline-block;
        margin: 0 10px;
      }

      a {
        color: #42b983;
      }
    }
  }
}
</style>